'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function () {
  function Header(el) {
    (0, _classCallCheck3.default)(this, Header);

    /* Fix header stuff */
    this.els = {
      el: el,
      nav: (0, _functional.getElement)('.js-Header_Nav'),
      pageNav: (0, _functional.getElement)('.nav-PageNav_Surround')
    };

    this.isTicking = false;
    this.lastKnownY = window.scrollY || window.pageYOffset;
    this.fixedTriggerPoint = this.getFixedTriggerPoint();
    this.offsetTrackedY = 0;
    this.scrollDirection = null;
    this.scrollUpOffset = 350;

    this.onScroll = this.onScroll.bind(this);
    this.updateEl = this.updateEl.bind(this);

    this.setupListeners();
  }

  (0, _createClass3.default)(Header, [{
    key: 'getFixedTriggerPoint',
    value: function getFixedTriggerPoint() {
      return (0, _utils.getOffsetTop)(this.els.nav);
    }
  }, {
    key: 'setupListeners',
    value: function setupListeners() {
      var _this = this;

      window.addEventListener('scroll', this.onScroll);

      window.addEventListener('resize', function () {
        _this.fixedTriggerPoint = _this.getFixedTriggerPoint();
      });
    }
  }, {
    key: 'onScroll',
    value: function onScroll() {
      var previouslyKnown = this.lastKnownY;
      var previousDirection = this.scrollDirection;

      this.lastKnownY = window.scrollY || window.pageYOffset;
      this.scrollDirection = previouslyKnown < this.lastKnownY ? 'down' : 'up';

      if (previousDirection !== this.scrollDirection) {
        this.offsetTrackedY = this.lastKnownY;
      }

      this.requestTick();
    }
  }, {
    key: 'requestTick',
    value: function requestTick() {
      if (!this.isTicking) window.requestAnimationFrame(this.updateEl);

      // If a rAF is already queued we don't want to call another one
      this.isTicking = true;
    }
  }, {
    key: 'updateEl',
    value: function updateEl() {
      // Reset the tick so we can capture the next onScroll
      this.isTicking = false;

      // Set whether the navigation is fixed or not
      this.els.el.classList.toggle('js-Header-fixed', this.lastKnownY >= this.fixedTriggerPoint);

      var stickyNav = document.querySelector('.spg-Nav_Inner');

      this.els.el.classList.toggle('js-Header-showFull', this.scrollDirection === 'up' && this.offsetTrackedY > this.lastKnownY + this.scrollUpOffset);

      if (stickyNav) {
        stickyNav.classList.toggle('spg-Inner_HeaderShow', this.scrollDirection === 'up' && this.offsetTrackedY > this.lastKnownY + this.scrollUpOffset);
      }

      if (this.els.pageNav) {
        this.els.pageNav.classList.toggle('js-Header-showFull', this.scrollDirection === 'up' && this.offsetTrackedY > this.lastKnownY + this.scrollUpOffset);
        if (stickyNav) {
          stickyNav.classList.toggle('spg-Inner_HeaderShow', this.scrollDirection === 'up' && this.offsetTrackedY > this.lastKnownY + this.scrollUpOffset);
        }
      }
    }
  }]);
  return Header;
}();

exports.default = Header;